import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const tonPriceApi = createApi({
  reducerPath: 'tonApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://api.coingecko.com/api/v3/' }),
  endpoints: (builder) => ({
    getTonPrice: builder.query<number, void>({
      query: () => 'simple/price?ids=the-open-network&vs_currencies=usd',
      transformResponse: (response: { 'the-open-network': { usd: number } }) =>
        response['the-open-network'].usd,
    }),
  }),
});

export const { useLazyGetTonPriceQuery } = tonPriceApi;
